import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  LEAD_DETAILS_REFRESH: createSagaAction('LEAD_DETAILS_REFRESH'),

  LEAD_DETAILS_UPDATE: createSagaAction('LEAD_DETAILS_UPDATE'),
  LEAD_DELETE: createSagaAction('LEAD_DELETE'),

  LEAD_CLONE: createSagaAction('LEAD_CLONE'),

  FETCH_LEAD_CONTRACTS: createSagaAction('FETCH_LEAD_CONTRACTS'),
  CREATE_JOB_FROM_LEAD: createSagaAction('CREATE_JOB_FROM_LEAD'),

  LEAD_MARK_AS_DEAD: createSagaAction('LEAD_MARK_AS_DEAD')
}

// Action Creators
export const actions = {
  fetchLeadDetails: ({ leadId }) => ({
    type: constants.LEAD_DETAILS_REFRESH.ACTION,
    leadId
  }),

  updateLeadDetails: ({ leadId, content }) => ({
    type: constants.LEAD_DETAILS_UPDATE.ACTION,
    leadId,
    content
  }),

  deleteLead: ({ leadId }) => ({
    type: constants.LEAD_DELETE.ACTION,
    leadId
  }),

  markAsDeadLead: ({ leadId, markAsAlive }) => ({
    type: constants.LEAD_MARK_AS_DEAD.ACTION,
    leadId,
    markAsAlive
  }),

  cloneLead: ({ leadId, leadName }) => ({
    type: constants.LEAD_CLONE.ACTION,
    leadId,
    leadName
  }),

  fetchContracts: ({ leadId }) => ({
    type: constants.FETCH_LEAD_CONTRACTS.ACTION,
    leadId
  }),

  createJobFromLead: ({ content, leadId }) => ({
    type: constants.CREATE_JOB_FROM_LEAD.ACTION,
    content,
    leadId
  })
}

// Reducer
const initialState = [
  {
    createdDate: '',
    updatedDate: '',
    createdByFirstName: '',
    createdByLastName: '',
    updatedByFirstName: '',
    updatedByLastName: '',
    name: '',
    type: '',
    legacyJobId: '',
    CompanyName: '',
    parentJobId: '',
    description: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zip: ''
  }
]

export default createReducer(initialState, (state, { type, payload, contracts }) => {
  switch (type) {
    default:
      return state
    case constants.LEAD_DETAILS_REFRESH.SUCCESS:
      return { ...state, payload }
    case constants.LEAD_DETAILS_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.LEAD_DELETE.SUCCESS:
      return {
        ...state
      }
    case constants.LEAD_MARK_AS_DEAD.SUCCESS:
      return {
        ...state
      }
    case constants.LEAD_CLONE.SUCCESS:
      return {
        ...state
      }
    case constants.FETCH_LEAD_CONTRACTS.SUCCESS:
      return {
        ...state,
        contracts
      }
    case constants.CREATE_JOB_FROM_LEAD.SUCCESS:
      return {
        ...state
      }
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/leadDetails.js